/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global lng, schema, FormValidation, restCollection, autocompleete, Promise */

/**
 *
 * @param {Rest} rest
 * @returns {RestEdit}
 */
function RestEdit(rest) {
  if (!this instanceof RestEdit) return new RestEdit(rest);

  var that = this;

  // -- attributes --
  this.node = document.createElement("div");

  this._subject = null;
  this._restEditBasic = new RestEditBasic(rest);
  this._restEditCollections = [];
  this._restEditStatic = [];

  this.onclose = function () {
    console.warn("onclose() Overwrite this!");
  };
  this.onchange = function () {
    console.warn("onchange() Overwrite this!");
  };

  // -- functions --
  this.loadSubject = loadSubject;
  this.close = close;
  this.reload = reload;
  this.destroy = destroy;

  // -- init --
  (function () {
    that.node.classList.add("rest-edit");

    // -- close button --
    var closeButtonWrapper = document.createElement("i");
    closeButtonWrapper.insertAdjacentHTML("beforeend", schema.ICONS.ARROW_BACK);
    var closeButton = closeButtonWrapper.children[0];
    closeButton.classList.add("back");
    closeButton.addEventListener("click", (e) => close());
    that.node.appendChild(closeButton);

    var titleNode = document.createElement("h2");
    titleNode.textContent = lng.get(rest.schemaKey);
    that.node.appendChild(titleNode);

    // -- tabs --
    var tabs = document.createElement("div");
    tabs.classList.add("mdl-tabs__tab-bar");
    that.node.appendChild(tabs);
    var tabLinks = [];
    var tabPanels = [];

    // -- tabs css
    that.node.classList.add("mdl-tabs");
    that.node.classList.add("mdl-js-tabs");
    that.node.classList.add("mdl-js-ripple-effect");

    // -- basic edit --
    that.node.appendChild(that._restEditBasic.node);
    // -- add tab --
    var tabLink = document.createElement("a");
    tabLink.href = "#general-information";
    tabLink.textContent = lng.get("general-information");
    tabLink.classList.add("mdl-tabs__tab");
    tabLink.classList.add("is-active");
    tabs.appendChild(tabLink);

    that._restEditBasic.onchange = function () {
      that.reload();
      that.onchange();
    };
    that._restEditBasic.onclose = function () {
      close();
    };

    // -- static edit
    for (var key in rest.schemaData) {
      let schemaItem = rest.schemaData[key];

      // if no static - skip!
      if (schemaItem.type !== "static") continue;

      let rec = new RestEditStatic(rest, key);
      // rec => single page values
      rec.onchange = function () {
        //only reload the collection to avoid loosing not saved changes
        rec.loadSubject(that._subject);
        that.onchange();
      };

      that._restEditStatic.push(rec);
      that.node.appendChild(rec.node);

      rec.node.id = rec.node.id.replace(/ä|ö|ü|Ä|Ü|Ö|ß/g, "");
      // -- add tab --
      var tabLink = document.createElement("a");
      tabLink.href = "#" + rec.node.id;

      if (rec._staticSchema.label)
        tabLink.textContent = rec._staticSchema.label;
      else tabLink.textContent = rec.label;
      // where does the label come from?? I don't understand it
      // tabLink.textContent = 'justatab';
      tabLink.classList.add("mdl-tabs__tab");
      tabs.appendChild(tabLink);
    }

    // -- collection edit --
    for (let key in rest.schemaData) {
      let schemaItem = rest.schemaData[key];

      // if no collection - skip!
      if (schemaItem.type !== "collection" || !schemaItem.cols) continue;

      let rec = new RestEditCollection(rest, key);
      // rec => single page values
      rec.onchange = function () {
        //only reload the collection to avoid loosing not saved changes
        rec.loadSubject(that._subject);
        that.onchange();
      };
      that._restEditCollections.push(rec);
      rec.node.id = rec.node.id.replace(/ä|ö|ü|Ä|Ü|Ö|ß/g, "");
      that.node.appendChild(rec.node);

      // -- add tab --
      var tabLink = document.createElement("a");
      tabLink.href = "#" + rec.node.id;
      tabLink.textContent = rec._collectionSchema.label;
      tabLink.classList.add("mdl-tabs__tab");
      tabs.appendChild(tabLink);
    }
  })();

  function reload() {
    loadSubject(that._subject);
  }

  /**
   * Show the Wrapper and redirect the loadSubject operation to sub modules.
   * @param {RestSubject} subject
   * Use <i>null</i> for empty forms for creation a new object.
   * @param {object} options noAnimation
   * @returns {undefined}
   */
  function loadSubject(subject, options) {
    options = options || {};
    that._subject = subject;

    if (options.noAnimation) {
      requestAnimationFrame(() => {
        that.node.style.transition = "none";
        that.node.classList.add("active");

        requestAnimationFrame(() => {
          that.node.style.transition = null;
        });
      });
    } else {
      that.node.classList.add("active");
    }

    that._restEditBasic.loadSubject(that._subject);

    for (let i = 0, len = that._restEditCollections.length; i < len; i++)
      that._restEditCollections[i].loadSubject(that._subject);

    for (let i = 0, len = that._restEditStatic.length; i < len; i++)
      that._restEditStatic[i].loadSubject(that._subject);
  }

  /**
   * Simply hide this view and call the <i>onclose()</i> callback.
   * @returns {undefined}
   */
  function close() {
    that._subject = null;
    that.node.classList.remove("active");
    that.onclose();
  }

  /**
   * Try to remove as many as possible pointers to make the work for the gc easer
   * and possibly remove deadlocks.
   * @returns {Promise}
   */
  function destroy() {
    var promises = [];

    promises.push(that._restEditBasic.destroy);
    that._restEditCollections.map((rec) => promises.push(rec.destroy));
    that._restEditStatic.map((rec) => promises.push(rec.destroy));

    for (var i in that) that[i] = null;

    return Promise.all(promises);
  }
}

Object.defineProperty(RestEdit, "genInput", {
  enumerable: false,
  /**
   * Generates an input from schema item.
   * Autocomplete for <i>schemaItem.type='model'</i>. onAutoComplete is an optional callback
   * @param {object} schemaItem
   * @param {string} key
   * schema key
   * @param {Element} target
   * Input and error wrapper will be append to this
   * @param {Element} formWrapper
   * Will be used for blueprints.
   * @returns {Element}
   */
  value: function (schemaItem, key, target, formWrapper) {
    if (schemaItem.type === "area") {
      let input = document.createElement("textarea");
      input.name = key;

      target.appendChild(input);

      return input;
    } else if (schemaItem.type === "select") {
      let selectNode = document.createElement("select");
      selectNode.name = key;
      schemaItem.options.map((item) => {
        const option = document.createElement("option");
        option.value = item.value;
        option.textContent = item.text;
        selectNode.appendChild(option);
      });

      target.appendChild(selectNode);
    } else if (schemaItem.type === "button") {
      let input = document.createElement("input");
      input.type = "button";
      if (schemaItem.name) {
        input.value = schemaItem.name;
      } else {
        input.value = "Bearbeiten";
      }
      input.name = key;

      target.appendChild(input);

      return input;
    } else {
      let input = document.createElement("input");
      switch (schemaItem.type) {
        case "json":
          input.type = "button";
          input.value = "Bearbeiten";
          break;
        case "model":
          input.type = "text";
          break;
        default:
          input.type = schemaItem.type;
      }
      //input.type = schemaItem.type === 'model' ? 'text' : schemaItem.type;

      if (input.type === "password") {
        //autocomplete="off" does not work correctly.
        //Use this hack: https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
        input.autocomplete = "new-password";
      }

      input.name = key;

      // min, max
      if (schemaItem.min !== undefined) input.min = schemaItem.min;
      if (schemaItem.max !== undefined) input.max = schemaItem.max;
      if (schemaItem.step !== undefined) input.step = schemaItem.step;

      // minLength, maxLength
      if (
        schemaItem.minLength !== undefined &&
        schemaItem.maxLength === undefined
      )
        //minlength
        input.pattern = `.{${schemaItem.minLength},}`;
      else if (
        schemaItem.minLength === undefined &&
        schemaItem.maxLength !== undefined
      )
        //maxlength
        input.pattern = `.{,${schemaItem.maxLength}}`;
      else if (
        schemaItem.minLength !== undefined &&
        schemaItem.maxLength !== undefined
      )
        //min and maxlength
        input.pattern = `.{${schemaItem.minLength},${schemaItem.maxLength}}`;

      //input.required = !!schemaItem.required; //use this only on create mode, cause of some writeonly fields

      if (schemaItem.defaultsTo !== undefined) {
        switch (schemaItem.type) {
          case "checkbox":
            input.checked = schemaItem.defaultsTo;
            break;
          default:
            input.value = schemaItem.defaultsTo;
        }
      }

      target.appendChild(input);

      //errors
      var errorUl = document.createElement("ul");
      errorUl.classList.add("error");
      target.appendChild(errorUl);
      input.addEventListener("blur", function (e) {
        var errorUl = input.nextElementSibling;
        if (errorUl && errorUl.classList.contains("error"))
          errorUl.classList.remove("visible");
      });

      switch (schemaItem.type) {
        case "model": //search stuff on schema item model
          FormValidation.delayedTextInput(input, function (value) {
            let schemakey = schemaItem.via || key;
            let restToSearch = restCollection[schemakey];
            if (!restToSearch)
              throw new Error(`restCollection ${schemakey} not found`);

            restToSearch
              .textSearch({
                search: value,
              })
              .then((found) => {
                //make sure there is a name attribute
                var getString = schemaItem.getString;
                if (getString && found.length > 0) {
                  for (let i = 0, len = found.length; i < len; i++) {
                    let virtualRow = {};
                    virtualRow[key] = found[i];
                    const foundItem = found[i];

                    if (getString(virtualRow)) {
                      foundItem.name = getString(virtualRow);
                    }
                  }
                }

                autocompleete.use(input, found, function (val) {
                  var virtualRow = {};
                  virtualRow[key] = val;

                  if (schemaItem && schemaItem.getString(virtualRow)) {
                    input.value = schemaItem.getString(virtualRow);
                  } else {
                    input.value = virtualRow.partner.name;
                  }

                  input.data = val;

                  if (typeof input.onAutoCompleete === "function")
                    input.onAutoCompleete(val);

                  if (schemaItem.blueprint) {
                    for (let blueprintKey in val) {
                      var targetInput = formWrapper.querySelector(
                        "input[name=" + blueprintKey + "]"
                      );
                      if (!targetInput) {
                        targetInput = formWrapper.querySelector("select");

                        if (!targetInput) continue;
                      }

                      switch (targetInput.type) {
                        case "model":
                        case "collection":
                          break;
                        case "checkbox":
                          targetInput.checked = !!val[blueprintKey];
                          break;
                        default:
                          targetInput.value = val[blueprintKey];
                      }
                    }
                  }
                });
              });
          });
          break;
        case "file": //generate a thumbnail
          if (schemaItem.showThumbnail) {
            var imageThumb = document.createElement("img");
            imageThumb.classList.add("image-thumb");
            target.appendChild(imageThumb);
            break;
          } else {
            var td = document.createElement("td");
            td.classList.add("csv-td");
            var label = document.createElement("label");
            td.appendChild(label);
            label.classList.add("csv-name");
            target.appendChild(td);
            break;
          }
        case "area": //generate a text area
        case "button":
      }
      return input;
    }
  },
});
